import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'employee_guid': 'String!',
	'code': 'String!',
	'scanned_out_through': 'String'
}

export default gql(`
	mutation employee_scan_out_with_code( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_scan_out_with_code( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        code
	        
	        building {
	            guid
	        }
	        
	        timeslot_group {
	            guid
            }
            
            timeslot_kind {
                guid
            }
	    }
	}
`);

